import config from 'react-global-configuration'
config.set({
    ga_tag: "",
    ga_debug: false,
    base:"https://telecubesapis.bngrenew.com/apn",
    elastic_base_url:"https://serviceusagesv1.bngrenew.com/publish",
    domain : "btc",
    he : "/he",
    requestOTP: "/requestOTP",
    activate: "/activate",
    checkSub: "/checkSub",
    // unsubscribe : '/unsubscribe',
    unsubscribe : '/unsub_other',
    userPacks : '/userPacks',
    appConfig : '/config' , 
    subscribe:"/subscribe",
    sendOtp:"/pinsend",
    pinSubmit:"/pinsubmit",
    headers: {
        'Reqfrom': 'web',
        'Username': 'web',
        // 'Language': reactLocalStorage.get("lang")?reactLocalStorage.get("lang"):'en',
        'Servicefor':'etisalat_dubai'
    }
})


export default config